import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import { querySelector } from '../../../../utils';
import queryMetaHandler from '../../../../utils/queryMetaHandler';
import omitProps from '../../../../utils/omitProps';
import {
  GET_WEEKLY_TIMESHEETS_HOURS_QUERY,
  WEEKLY_TIMESHEET_ENTRY_QUERY,
  GET_TIMESHEETS_FOR_PAYPERIOD,
} from '../../../timesheetApprovals/graphql';

const TimeEntryFormFragment = gql`
  fragment TimeEntryFormFragment on TimeEntryForm {
    date
      pto_type
      ticket_number {
        id
        number
      }
      equipment{
        id
        equipment_number
      }
      start_time
      end_time
      notes
  }
`;

export const GET_TIME_ENTRY = gql`
  query TimeEntry ($timeEntryId: Int!) {
    time_entry(time_entry_id: $timeEntryId) {
      id
      time_entry_form {
        ...TimeEntryFormFragment
      }
    }
  }
  ${TimeEntryFormFragment}
`;

const marshallTimeEntry = ({ data, ownProps }) => {
  const timeEntries = querySelector(data, '$.time_entry.time_entry_form', []);
  const timeEntry = timeEntries[0];

  return {
    ...ownProps,
    data,
    timeEntry,
  };
};

const queryTimeEntry = graphql(GET_TIME_ENTRY, {
  props: marshallTimeEntry,
  options: { notifyOnNetworkStatusChange: true },
});

export const queryTimeEntryGQL = compose(
  queryTimeEntry,
  queryMetaHandler,
  omitProps(['data']),
);

const TimeEntryUpdateMutation = gql`
  mutation TimeEntryUpdate($input: TimeEntryUpdateInput!) {
    time_entry_update(input: $input) {
      id
      time_entry_form {
        ...TimeEntryFormFragment
      }
    }
  }
  ${TimeEntryFormFragment}
`;

// TODO - with some API cleanup, adding 'ids' or keys to the gql object, some of the caches
// would update for free. As is, with no id (or even identical object types) cache can't work
// effectively.
export const updateTimeEntry = (
  client,
  originaTimeEntryId,
  originaTimeEntryKey,
  newTimeEntryValues,
  supervisorId,
  userId,
  timesheetOriginDate,
) => {
  const identityObject = {
    id: originaTimeEntryId,
    key: originaTimeEntryKey,
  };

  const variables = {
    input: {
      time_entries: [{
        identity: identityObject,
        time_entry: newTimeEntryValues,
      }],
    },
  };

  const options = {
    mutation: TimeEntryUpdateMutation,
    variables,
    refetchQueries: [
      {
        query: GET_TIMESHEETS_FOR_PAYPERIOD,
        variables: {
          supervisorId,
          approvalState: 'unapproved',
        },
      },
      {
        query: GET_WEEKLY_TIMESHEETS_HOURS_QUERY,
        variables: {
          userId,
          originDate: timesheetOriginDate,
        },
      },
      {
        query: WEEKLY_TIMESHEET_ENTRY_QUERY,
        variables: {
          userId,
          originDate: timesheetOriginDate,
        },
      },
    ],
  };

  return client.mutate(options);
};


const TimeEntryCreateMutation = gql`
  mutation TimeEntryCreate($input: TimeEntryCreateInput!) {
    time_entry_create(input: $input) {
      key
    }
  }
`;

export const createTimeEntry = (
  client,
  newTimeEntryValues,
  districtId,
  userId,
  timesheetOriginDate,
) => {
  const variables = {
    input: {
      time_entries: [{
        user_id: userId,
        time_entry: newTimeEntryValues,
      }],
    },
  };

  const options = {
    mutation: TimeEntryCreateMutation,
    variables,
    refetchQueries: [
      {
        query: GET_TIMESHEETS_FOR_PAYPERIOD,
        variables: {
          districtId,
          approvalState: 'unapproved',
        },
      },
      {
        query: GET_TIMESHEETS_FOR_PAYPERIOD,
        variables: {
          districtId,
          approvalState: 'approved',
        },
      },
      {
        query: GET_WEEKLY_TIMESHEETS_HOURS_QUERY,
        variables: {
          userId,
          originDate: timesheetOriginDate,
        },
      },
      {
        query: WEEKLY_TIMESHEET_ENTRY_QUERY,
        variables: {
          userId,
          originDate: timesheetOriginDate,
        },
      },
    ],
  };

  return client.mutate(options);
};
